//Animation reveal titres
// const ratio = .1
// const options = {
//     root: null,
//     rootMargin: '0px',
//     threshold: ratio
// }
// const handleIntersect = function (entries, observer) {
//     entries.forEach(function (entry) {
//         if (entry.intersectionRatio > ratio) {
//             entry.target.classList.add('reveal-visible');
//             observer.unobserve(entry.target);
//         }
//     })
// }
// window.addEventListener("DOMContentLoaded", function () {
//     const observer = new IntersectionObserver(handleIntersect, options)
//     const targets = document.querySelectorAll('.reveal');
//     targets.forEach(function (target) {
//         observer.observe(target);
//     })
// })


document.addEventListener("DOMContentLoaded", function () {
// Appel de la gestion de cookies RGPD
    let cookies = document.querySelector(".cookies");
    cookies.addEventListener("click", function (e) {
        e.preventDefault();
        if (tarteaucitron) {
            tarteaucitron.userInterface.openPanel();
        }
    });

    /*=============================================>>>>>
  = Topbut =
  ===============================================>>>>>*/
    let btn = document.querySelector("#topbut");
    if (btn != null) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 300) {
                btn.classList.add("visible");
            } else {
                btn.classList.remove("visible");
            }
        });
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("html").scrollTop = 0;
            document.querySelector("body").scrollTop = 0;
        });
    }

    /*=============================================>>>>>
   = Menu au scroll =
   ===============================================>>>>>*/
    function fixedMenu() {
        let navbar = document.getElementById("main-nav");
        if (window.scrollY >= 135) {
            navbar.classList.add("scrolled");
        } else {
            navbar.classList.remove("scrolled");
        }
    }
    document.addEventListener("scroll", () => {
        fixedMenu();
    });


    /*=============================================>>>>>
    = Slider Certifications =
    ===============================================>>>>>*/
    const sliderCertifications = document.querySelector('#certifications');
    if (sliderCertifications) {
        const flktysliderCertifications = new Flickity(sliderCertifications, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "center",
            "prevNextButtons": false,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false
        });
    }

    if ( matchMedia('screen and (min-width: 1200px)').matches ) {
        let elementsCertifications = document.querySelectorAll('.certifications-slider.no-slider');
        for (let i = 0; i < elementsCertifications.length; i++) {
            let flktyCertifications = Flickity.data(elementsCertifications[i]);
            flktyCertifications.destroy();
        }
    }


    /*=============================================>>>>>
    = Chiffres animés =
    ===============================================>>>>>*/
    window.addEventListener("scroll", chiffresScroll);
    let viewed = false;
    function isScrolledIntoView(elem) {
        if (elem != null) {
            let docViewTop = window.scrollY || document.documentElement.scrollTop;
            let docViewBottom = docViewTop + window.innerHeight;

            let elemTop = elem.offsetTop;
            let elemBottom = elemTop + elem.offsetHeight;

            return elemBottom <= docViewBottom && elemTop >= docViewTop;
        }
    }
    function chiffresScroll() {
        let colChiffres = document.querySelector(".bloc-chiffres");
        if (isScrolledIntoView(colChiffres) && !viewed) {
            viewed = true;
            let chiffres = document.querySelectorAll(".chiffres");
            chiffres.forEach(function (element) {
                let startCount = 0;
                let endCount = parseInt(element.textContent.replace(" ", ""));
                let duration = 4000;
                let range = endCount - startCount;
                let currentCount = startCount;
                let increment = endCount > startCount ? 1 : -1;
                let stepTime = Math.abs(Math.floor(duration / range));

                let timer = setInterval(function () {
                    currentCount += increment;
                    element.textContent = currentCount.toLocaleString();
                    if (currentCount === endCount) {
                        clearInterval(timer);
                    }
                }, stepTime);
            });
        }
    }

    /*=============================================>>>>>
    = OFFRES =
    ===============================================>>>>>*/
    var offres = jQuery('#offres');
    if (offres) {
        ajaxOffres();
    }


    /*=============================================>>>>>
    = IMAGE MAISON - PAGE ACCUEIL =
    ===============================================>>>>>*/
    let svgItem = document.querySelector('#svg');
    let paths = document.querySelectorAll(".gr");
    let card = document.querySelector('#card');
    paths.forEach((p) => {
        p.addEventListener("mouseleave", (evt) => {
            card.style.display = "none";
        });
        p.addEventListener("mousemove", (evt) => {
            let pos = oMousePos(svgItem, evt);
            let text = p.dataset.text;
            card.style.display = "block";
            card.style.top = pos.y + "px";
            card.style.left = pos.x + "px";
            card.innerHTML = text;
        });
    });
    function oMousePos(element, evt) {
        let ClientRect = element.getBoundingClientRect();
        return {
            //objeto
            x: Math.round(evt.clientX - ClientRect.left),
            y: Math.round(evt.clientY - ClientRect.top)
        };
    }



    if(document.getElementById('myPopUp')) {
        let myModal = document.getElementById('myPopUp');

        let closeButton = document.querySelector('.btn-close-modal');
        if (closeButton != null) {
            closeButton.addEventListener('click', function () {
                myModal.classList.add('no-visible');
            });
        }
        window.addEventListener('click', function (event) {
            let modal = document.getElementById('myPopUp');
            if (event.target === modal) {
                myModal.classList.add('no-visible');
            }
        });
    }
});



function ajaxOffres(type="offre", page = '1') {
    // Afficher le loader
    let loader = document.querySelector('.loader');
    if (loader != null) {
        loader.classList.add('visible');
    }

    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_offres',
            type: type,
            page: page,
        },
        success: function (res) {
            if (res) {
                jQuery('#offres').html(res);
                // Cacher le loader
                if (loader != null) {
                    loader.classList.remove('visible');
                }
                let page = jQuery(".page-numbers").on("click", function (e) {
                    e.preventDefault();
                    ajaxOffres( 'offre', jQuery(this).data("page"));
                    window.location.href = "/nous-rejoindre/#offres-container";
                });
            }
        }
    });


}
